export default {"src":"/_next/static/media/fairplay_footer_light_theme.cb7f5e19.svg","height":41,"width":197,"blurWidth":0,"blurHeight":0};